/**
 * Interface del estado del store de layout de la plataforma
 * * Modal activo (lanzado desde alguna de las pantallas)
 * * Snack activo (lanzado desde alguna de las pantallas)
 * * Flag de si está el loading de page de consorcio activo
 */
export interface CALayoutState {
  modal_activo: {
    mostrar: boolean,
    tipo: string,
    titulo: string,
    texto: string,
    detalle?: string
  }|null,
  snack_activo: {
    mostrar: boolean,
    error: boolean,
    texto: string,
    duracion?: number
  }|null,
  loading: boolean
}

// Mutations de modal (docs en definición de métodos en layout.ts)
export const LAYOUT_MUTATION_MODAL = 'mostrarModal';
export const LAYOUT_MUTATION_MODAL_EXITO = 'mostrarModalExito';
export const LAYOUT_MUTATION_MODAL_ERROR = 'mostrarModalError';
export const LAYOUT_MUTATION_MODAL_ADVERTENCIA = 'mostrarModalAdvertencia';
export const LAYOUT_MUTATION_CERRAR_MODAL = 'cerrarModal';

// Mutations de snackbar (docs en definición de métodos en layout.ts)
export const LAYOUT_MUTATION_SNACKBAR_EXITO = 'mostrarSnackbarExito';
export const LAYOUT_MUTATION_SNACKBAR_ERROR = 'mostrarSnackbarError';
export const LAYOUT_MUTATION_OCULTAR_SNACKBAR = 'ocultarSnackbar';

// Mutations de loading
export const LAYOUT_MUTATION_LOADING = 'setLoading';
export const LAYOUT_MUTATION_MOSTRAR_LOADING = 'showLoading';
export const LAYOUT_MUTATION_OCULTAR_LOADING = 'hideLoading';

/**
 * Shortcut para cuando se necesitan mapear varias mutations en un componente
 * (después se importa cada una por separado para invocar)
 */
export const LAYOUT_MUTATIONS = [
  LAYOUT_MUTATION_MODAL,
  LAYOUT_MUTATION_MODAL_ERROR,
  LAYOUT_MUTATION_MODAL_EXITO,
  LAYOUT_MUTATION_MODAL_ADVERTENCIA,
  LAYOUT_MUTATION_CERRAR_MODAL,
  LAYOUT_MUTATION_SNACKBAR_EXITO,
  LAYOUT_MUTATION_SNACKBAR_ERROR,
  LAYOUT_MUTATION_OCULTAR_SNACKBAR,
  LAYOUT_MUTATION_LOADING,
  LAYOUT_MUTATION_OCULTAR_LOADING,
  LAYOUT_MUTATION_MOSTRAR_LOADING
];

// Getter de modal
export const LAYOUT_GETTER_MODAL_ACTIVO = 'modalActivo';

// Getter de snack
export const LAYOUT_GETTER_SNACK_ACTIVO = 'snackActivo';

// Getter Loading
export const LAYOUT_GETTER_LOADING = 'getLoading';

// Getter ancho Sidemenu
export const LAYOUT_GETTER_ANCHO_SIDEMENU = 'getAnchoSidemenu';